import type { SearchFacets } from "./search-filters";

const EMPTY_COUNTS: Record<string, number> = {};
const EMPTY_FACET_COUNTS: { value: string; count: number }[] = [];

export function searchFacetValues(facets: SearchFacets | null) {
  if (!facets) {
    return {
      typeCounts: EMPTY_COUNTS,
      formatCounts: EMPTY_COUNTS,
      genreCounts: EMPTY_FACET_COUNTS,
      styleCounts: EMPTY_FACET_COUNTS,
      labelCounts: EMPTY_FACET_COUNTS,
      companyCounts: EMPTY_FACET_COUNTS,
      countryCounts: EMPTY_FACET_COUNTS,
      artistCountryCounts: EMPTY_FACET_COUNTS,
      yearCounts: EMPTY_FACET_COUNTS,
    };
  }
  return facets;
}
